import { deleteCookie } from "cookies-next";
import toast from "@/lib/toast"
import { useLocation, useNavigate } from "react-router-dom";
import { SWRConfig } from "swr";

function SWRProivder({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isConsole = location.pathname.startsWith("/console");

  const handleUnauthenticated = () => {
    deleteCookie("token");
    deleteCookie("role");
    toast.error("You are unauthorized to access this page. Please login.");
    if (isConsole) {
      navigate("/console/login", { replace: true });
    } else {
      navigate("/app/login", { replace: true });
    }
  };

  const handleNotFound = () => {
    if (isConsole) {
      navigate("/console/not-found", { replace: true });
    } else {
      navigate("/app/not-found", { replace: true });
    }
  };

  const handleUnexpectedError = () => {
    navigate("/unexpected-error", { replace: true });
  };

  const handleServerOfflineError = () => {
    toast.error("Unable to connect to server.");
    navigate("/", { replace: true });
  };

  const handleGeneralError = (message: string) => {
    toast.error(message);
  };

  return (
    <SWRConfig
      value={{
        onError: (error) => {
          const status = parseInt(error?.status);
          if (isNaN(status)) {
            const message = error?.message;
            if (typeof message === "string") {
              handleGeneralError(message);
              return;
            }
            toast.error("Something went wrong.");
            return;
          }
          if (status === 401) {
            handleUnauthenticated();
            return;
          }
          if (status === 403) {
            handleUnauthenticated();
            return;
          }
          if (status === 404) {
            handleNotFound();
            return;
          }
          if (status === 500) {
            handleUnexpectedError();
            return;
          }
          if (status === 0) {
            handleServerOfflineError();
            return;
          }
        },
        shouldRetryOnError: false,
        onSuccess: (data) => {
          if (data.message) {
            toast.success(data.message);
          }
        },
      }}
    >
      {children}
    </SWRConfig>
  );
}

export default SWRProivder;
